import "@webcomponents/custom-elements/src/native-shim";
import "../../styles/theme.scss";
import { setupChatApp } from '../services/chat.service';
import { functionalCookieConsent$, functionalCookieConsentAllowedOnce$, strictlyNecessaryCookieConsentAllowedOnce$ } from '../services/consent.service';
import { isOnPage, waitForElements, getElementOrParentByClassName, getFutureDate } from '../helpers/utils';
import { scrollTo } from '../helpers/scrollPage';
import Cookies from "js-cookie";
import { getCart, updateCart, cartSubject$ } from '../services/cart.service';
// modules
import DyEvents from '../modules/DyEvents';
import Accordion from '../modules/Accordion';
import Form from '../modules/Form';
import Meganav from '../modules/Meganav';
import VideoModal from '../modules/VideoModal';
import InlineCart from '../modules/InlineCart';
import Nav from '../modules/Nav';
import Scroll from '../modules/Scroll';
import LazyImages from '../modules/LazyImages';
import CustomCheckbox from '../modules/CustomCheckbox';
import { attachSessionIdsToCart, emitShopifyEvent, getCSQGlobal, dialogStack } from "../services/analytics.service";
import { initMediaContentListeners } from '../services/media-content.service';
import '../web-components/product-main';
import '../web-components/loading-spinner';
import '../web-components/cart-progress';
import '../web-components/cart-line-item';
import '../web-components/global-banner';
import '../web-components/main-nav-desktop';
import '../web-components/main-nav-mobile';
import '../web-components/selected-store';
import '../web-components/search-form';
import '../web-components/save-for-later-list';
import '../web-components/carousel-selector';
import '../web-components/review-carousel';
import '../web-components/quickshop';
import '../web-components/color-swatch-list';
import { setSelectedStore, selectedStore$ } from "../services/store.service";
import { initSaveForLater, initWishlistEventListeners } from "../services/wishlist.service";
getCart(); // initialize cart state
// Layout
class ThemeLayout {
    constructor() {
        console.log('UNTUCKit : Layout : Theme : loaded', this);
    }
    ready() {
        console.log('UNTUCKit : Layout : Theme : ready', this);
        Accordion.init();
        Form.init();
        CustomCheckbox.init();
        Meganav.init();
        VideoModal.init();
        Nav.init();
        Scroll.init();
        // Global
        LazyImages.update();
        initMediaContentListeners();
        // per pieeye, chat can by considered "strictly necessary" in the US
        // since chat is only available in the US, we're executing on all page loads
        // will need to update if we expand chat to CA/UK
        if (window.Shopify.country === "US") {
            strictlyNecessaryCookieConsentAllowedOnce$.subscribe(setupChatApp);
        }
        functionalCookieConsent$.subscribe((consent) => {
            findifyConsent(consent);
        });
        functionalCookieConsentAllowedOnce$.subscribe(() => {
            DyEvents.init();
            attachSessionIdsToCart();
            initWishlistEventListeners();
            document.addEventListener('click', (e) => {
                const target = e.target;
                if (getElementOrParentByClassName(target, "js-marketing-opt-in")) {
                    e.preventDefault();
                    if (window.__attentive) {
                        if (window.innerWidth >= 760) {
                            window.__attentive.trigger(null, null, null, window.UNTUCKitConfig.thirdPartyToggles.attentiveManualPopupDesktopId);
                        }
                        else {
                            window.__attentive.trigger(null, null, null, window.UNTUCKitConfig.thirdPartyToggles.attentiveManualPopupMobileId);
                        }
                    }
                }
            });
            if (window.UNTUCKitConfig.nearbyToggle.enable) {
                let handle;
                if (isOnPage("collection-instore")) {
                    const parts = window.location.pathname.split('/');
                    handle = parts.length >= 2 ? parts[2] : null;
                }
                setSelectedStore(handle);
            }
            selectedStore$.subscribe((store) => {
                if (store) {
                    const cart = cartSubject$.getValue();
                    if (cart && store.COLLECTION_HANDLE && cart?.attributes?._selected_store_handle !== store.COLLECTION_HANDLE) {
                        updateCart({
                            attributes: {
                                _selected_store_handle: store.COLLECTION_HANDLE
                            }
                        });
                    }
                }
            });
            // handle nobi search dialog
            window.addEventListener('nobi-close-drawer', () => {
                dialogStack.pop('nobi-search');
            });
            window.addEventListener('nobi-chatbot-viewed', () => {
                dialogStack.push('nobi-search');
            });
        });
        const params = new URLSearchParams(window.location.search);
        if (params && params.get("highstreet")) {
            // attempt to keep app users within the "app view"
            const links = Array.from(document.querySelectorAll("a[href^='/'], a[href*='untuckit.']:not([href^='mailto'])"));
            links.forEach((l) => {
                if (l.href) {
                    l.href += `${(l.href.includes("?") ? "&" : "?")}highstreet=true&hlt=1`;
                }
            });
        }
    }
    load() {
        InlineCart.init();
        document.addEventListener("submit", handleCheckoutFormSubmit);
    }
}
const untuckitTheme = new ThemeLayout();
$(() => {
    untuckitTheme.ready();
});
$(window).on('DOMContentLoaded', () => {
    untuckitTheme.load();
});
/**
 * prevents back-forward caching, which can cause cached data to be displayed.
 * see: https://web.dev/bfcache/
 *
 */
window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
        window.location.reload();
    }
});
/**
 *
 * @param {SubmitEvent} e
 */
async function handleCheckoutFormSubmit(e) {
    const target = e.target;
    if (target.action?.includes('/checkout')) {
        const checkoutSpinnerEl = target.querySelector('.js-checkout-spinner');
        if (checkoutSpinnerEl) {
            checkoutSpinnerEl.classList.remove('hidden');
        }
        const checkoutTextEl = target.querySelector('.js-checkout-text');
        if (checkoutTextEl) {
            checkoutTextEl.textContent = window.UNTUCKitConfig.checkoutLoadingText;
        }
        // check if narvar shop now; otherwise allow form submission to continue (i.e. no e.preventDefault)
        if (typeof window.nv_shopnow?.hasSession === 'function'
            && window.nv_shopnow.hasSession()
            && typeof window.nv_shopnow.checkout === 'function') {
            try {
                e.preventDefault();
                const res = await window.nv_shopnow.checkout();
                location.replace(res.weburl);
            }
            catch (err) {
                console.error("narvar shop now error", err.message || err);
            }
        }
    }
}
const customerData = window.segmentLayer?.customer;
if (customerData) {
    emitShopifyEvent("utk_identify_customer", window.segmentLayer.customer);
    if (customerData.email) {
        getCSQGlobal().push(["trackPageEvent", `@user-identifier@${customerData.email}`]);
    }
}
if (window.UNTUCKitConfig.thirdPartyToggles.swym && window.UNTUCKitConfig.thirdPartyToggles.swymSaveForLater) {
    initSaveForLater();
}
/**
 * workaround due to the url hash not anchoring for dynamically-generated content
 * ex: https://www.untuckit.com/collections/shirts?section=shopify-section-collection-template-boost-pfs-filter
 */
window.addEventListener('DOMContentLoaded', () => {
    const section = new URLSearchParams(location.search).get('section');
    if (section) {
        waitForElements(`#${section}`).then((els) => {
            scrollTo(els[0]);
        });
    }
});
/**
 * enable/disable Findify tracking
 * see: https://developers.findify.io/docs/merchants-obligations#right-to-restrict-processing
 */
function findifyConsent(allowed) {
    if (allowed) {
        Cookies.remove("findify_optout");
    }
    else {
        Cookies.set("findify_optout", "1", { expires: getFutureDate(365) });
    }
}
